







import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            currentPage: this.current,
            currentPageSize: this.pageSize
        }
    },
    props: {
        total: {
            type: Number,
            default: 30,
        },
        pageSize: {
            type: Number,
            default: 10
        },
        current: {
            type: Number,
            default: 1,
        }
    },
    watch: {
        total (val) {
            let maxPage = Math.ceil(val / this.currentPageSize);
            if (maxPage < this.currentPage && maxPage > 0) {
                this.currentPage = maxPage;
            }
        },
        current (val) {
            this.currentPage = val;
        },
        pageSize (val) {
            this.currentPageSize = val;
        }
    },
    computed: {
        allPages () {
            const allPage = Math.ceil(this.total / this.currentPageSize);
            return (allPage === 0) ? 1 : allPage;
        },
        pagiLabel(): string {
            return `${this.currentPage}/${this.allPages}`
        }
    },
    methods: {
        prev () {
            const current = this.currentPage;
            if (current <= 1) {
                return false;
            }
            this.changePage(current - 1);
        },
        next () {
            const current = this.currentPage;
            if (current >= this.allPages) {
                return false;
            }
            this.changePage(current + 1);
        },
        changePage (page: number) {
            if (this.currentPage != page) {
                this.currentPage = page;
                this.$emit('onChange', page);
            }
        },
    }
})
